/** @flow */

export const ReportLogTypes = {
  ABSENCE_DETAILS: "ABSENCE_DETAILS",
  RTW_DETAILS: "RTW_DETAILS",
  ALERT_DETAILS: "ALERT_DETAILS",
  ABSENCE_REASON_TRENDS: "ABSENCE_REASON_TRENDS",
  ABSENCE_RATE_TRENDS: "ABSENCE_RATE_TRENDS",
  COMPLIANCE_TRENDS: "COMPLIANCE_TRENDS",
  EMPLOYEE_FOCUS_LIST: "EMPLOYEE_FOCUS_LIST",
  ORGANISATIONAL_UNIT_FOCUS_LIST: "ORGANISATIONAL_UNIT_FOCUS_LIST",
  MANAGER_FOCUS_LIST: "MANAGER_FOCUS_LIST",
  ABSENCE_MONITORING_DETAILS: "ABSENCE_MONITORING_DETAILS",
};
export const ReportActionTypesEnums = {
  EDIT: "EDIT",
  DUPLICATE: "DUPLICATE",
  RENAME: "RENAME",
  DELETE: "DELETE",
};

export const answerTypesEnum = {
  FREE_TEXT: "TEXT",
  DATE_PICK: "DATE",
  SINGLE_SELECT: "TEXT",
  MULTI_SELECT: "TEXT_LIST",
  CONFIRMATION: "BOOLEAN",
};

export const ReportModalStepTypes = {
  FILTERS: "filters",
  COLUMNS: "columns",
  TABLE: "table",
};

export const ReportChartColors = [
  "#FF871A", // coffee-d1
  "#9E51B2", // berry-d1
  "#3EC9F7", // ice-d1
  "#5BCB42", // mint-d1
  "#004F9F", // ice-d3
  "#5C8068", // mint-d2
  "#786780", // berry-d2
  "#000000",
];

export const WEEKLY = "WEEKLY";

export const COLOR_BY_ACTIVITY_CODE = {
  ALERT: "yellow", // alert
  "ABSENCE-U": "grey", // updated
  "ABSENCE-UC": "green", // closed
  "ABSENCE-OU": "red", // new
  "ABSENCE-OUC": "green", // opened and closed
  RTW: "orange", // rtw
  NOTE: "blue", // note added
  DOCUMENT: "purple", // document uploaded
  MONITORING: "pink", // monitoring review
};

export const ACTIVITY_FEED_TYPES = {
  ABSENCEOU: "ABSENCE-OU",
  ABSENCEUC: "ABSENCE-UC",
  ABSENCEU: "ABSENCE-U",
  NOTE: "NOTE",
  DOCUMENT: "DOCUMENT",
  RTW: "RTW",
};

export const SUPPLIER_REFERRAL_REPORT_TYPE = {
  NEW_REFERRALS: "NEW_REFERRALS",
  ACTIVE_REFERRALS: "ACTIVE_REFERRALS",
  CLOSED_REFERRALS: "CLOSED_REFERRALS",
};

export const SUPPLIER_REFERRAL_STATUSES = {
  ACTIVE: "ACTIVE",
  INAPPROPRIATE_REFERRAL: "INAPPROPRIATE_REFERRAL",
  ALL: "ALL",
};

export const SUPPLIER_REFERRAL_REPORT_ACTION_TYPE = {
  ACCEPT_REFUSE: "ACCEPT_REFUSE",
  ACKNOWLEDGE: "ACKNOWLEDGE",
};

export const PERCENTAGE = "PERCENTAGE";
